module.exports = __webpack_public_path__ + "img/kkb_netlase.17951304.jpg";